import request from "@/router/request";

//****预约挂号****/
//获取预约挂号科室
export const GetReserveRegisterDeptList = (orgCode) => {
    return request({
        url: '/api/HosBusiness/GetReserveRegisterDeptList',
        method: "get",
        params: {
            orgCode
        },
        meta: {
            isToken: false
        }
    });
}

//获取预约挂号医生分时号源信息
export const GetReserveRegisterDoctorAndNumList = (query) => {
    return request({
        url: '/api/HosBusiness/GetReserveRegisterDoctorAndNumList',
        method: "get",
        params: query,
        meta: {
            isToken: false
        }
    });
}

//HIS预约挂号确认
export const ReserveRegisterConfirm = (data) => {
    return request({
        url: '/api/HosBusiness/ReserveRegisterConfirm',
        method: "post",
        data: data,
        meta: {
            isToken: false
        }
    });
}
//****END****/
//*****当日挂号*****//
//获取当日挂号科室信息
export const GetRegisterDeptList = (query) => {
    return request({
        url: '/api/HosBusiness/GetRegisterDeptList',
        method: "get",
        params: query,
        meta: {
            isToken: false
        }
    });
}

//获取当日挂号医生号源信息
export const GetRegisterDoctorNumList = (query) => {
    return request({
        url: '/api/HosBusiness/GetRegisterDoctorNumList',
        method: "get",
        params: query,
        meta: {
            isToken: false
        }
    });
}

//HIS当日挂号确认
export const RegisterConfirm = (data) => {
    return request({
        url: '/api/HosBusiness/RegisterConfirm',
        method: "post",
        data: data,
        meta: {
            isToken: false
        }
    });
}
//****END****/
//****获取患者信息****/
//身份证建档
export const BindArchives = (data) => {
    return request({
        url: '/api/HosBusiness/BindArchives',
        method: "post",
        data: data
    });
}

//根据就诊卡号获取患者信息
export const GetPatientInfo = (query) => {
    return request({
        url: '/api/HosBusiness/GetPatientInfo',
        method: "get",
        params: query
    });
}
//****END****/
//获取挂号/预约挂号记录
export const QueryRegisterRecordList = (query) => {
    return request({
        url: '/api/HosBusiness/QueryRegisterRecordList',
        method: "get",
        params: query
    });
}